import {
    DashboardIcon,
    ApplicationsIcon,
    SettingsIcon,
    ModelIcon,
    TeamsIcon,
    FaqIcon,
    ChatIcon,
    LogoutIcon
} from "../components/common/IconComponents"

const links = [
  { id: 1, text: "Dashboard", path: "/dashboard", icon: DashboardIcon },
  { id: 2, text: "Applications", path: "applications", icon: ApplicationsIcon },
  { id: 3, text: "Models", path: "models", icon: ModelIcon },
  { id: 4, text: "Settings", path: "settings", icon: SettingsIcon },
  { id: 5, text: "Teams", path: "teams", icon: TeamsIcon },
  { id: 6, text: "FAQs", path: "faq", icon: FaqIcon },
  { id: 7, text: "Chat", path: "chat", icon: ChatIcon },
  { id: 8, text: "Log out", path: "logout", icon: LogoutIcon },
];

export default links;